/**
 * Page visibility flags.
 *
 * Self-serve is on for the RPC product: sign-in, keys, usage, and billing.
 * Prices live on /pricing (which mirrors willow.tech/pricing) and on the
 * Billing page. The Subgroves section stays hidden (the storage product is
 * parked).
 */

/** Sign in / sign up / account: header pill, auth routes, password flows,
 *  and the RPC account pages (/account, /keys, /usage, /billing). */
export const SHOW_AUTH_PAGES = true;

/** Subgroves tab, routes, and the home-page links into them. */
export const SHOW_SUBGROVES = false;

/** Storage-nodes section on the Network screen; file storage is parked for now. */
export const SHOW_STORAGE_NODES = false;
